import { useRouter } from "@tanstack/react-router";
import { IconUserPlus } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";

export function OrganizationsPrimaryButtons() {
  const router = useRouter();

  return (
    <div className="flex gap-2">
      <Button
        className="space-x-1"
        onClick={() => {
          void router.navigate({
            to: "/root-user/organization/create-organization",
          });
        }}
      >
        <span>Add Organization</span> <IconUserPlus size={18} />
      </Button>
    </div>
  );
}
